export default __webpack_public_path__ + "static/media/DMRC-NMRC-and-NCRTC-MAP-10.09.2026.3fc17df1.jpg";